<template>
  <div class="full-width">
    <div
      layout="column"
      layout-align="start start"
      class="full-width mb20-pc px2-pc pb1-pc mb2-mobile px1-mobile bg-white"
    >
      <div
        layout="row"
        layout-align="start center"
        class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc"
      >
        {{$t('stats.connections')}}
        <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1">
          <i
            :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']"
            style="color: black"
          ></i>
        </v-btn>
      </div>
      <div
        v-if="!$vuetify.breakpoint. smAndDown || displayFilters"
        layout="row"
        layout-wrap
        layout-align="start center"
        class="full-width pb1-mobile"
      >
        <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
          <v-select
            :label="$t('_.period')"
            :hint="$t('_.period_hint')"
            persistent-hint
            solo
            v-model="filters.mode"
            :items="modes"
            @change="today"
            class="mr5-pc width-100-mobile"
          ></v-select>
        </div>
        <span flex></span>
        <div layout="column" layout-align="center center">
          <div layout="row" layout-align="center center">
            <v-btn @click="subtract" icon color="secondary" small depressed>
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn @click="today" color="secondary" depressed outline small>{{$t('stats.today')}}</v-btn>
            <v-btn @click="add" icon color="secondary" small depressed>
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
          <span>{{displayedDate}}</span>
        </div>
      </div>
    </div>
    <div
      layout="column"
      layout-align="start start"
      class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white"
    >
      <reactive-chart
        :is="'line-chart'"
        :chart-data="chartData"
        :options="options"
        style="width: 100%"
      ></reactive-chart>
    </div>
    <div
      layout="column"
      layout-align="start start"
      class="full-width mb20-pc px2-pc pb1-pc mb2-mobile px1-mobile bg-white"
      style="margin-top :10px"
    >
      <div
        layout="row"
        layout-align="start center"
        class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc"
      >
        {{$t('stats.co_lvs')}}
        <v-btn @click="displayFilters2 = !displayFilters2" icon class="hidden-md-and-up ml-1">
          <i
            :class="['mdi', displayFilters2 ? 'mdi-filter-remove' : 'mdi-filter']"
            style="color: black"
          ></i>
        </v-btn>
      </div>
      <div
        v-if="!$vuetify.breakpoint. smAndDown || displayFilters2"
        layout="row"
        layout-wrap
        layout-align="start center"
        class="full-width pb1-mobile"
      >
        <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
          <v-select
            :label="$t('_.period')"
            :hint="$t('_.period_hint')"
            persistent-hint
            solo
            v-model="filters2.mode"
            :items="modes"
            @change="today2"
            class="mr5-pc width-100-mobile"
          ></v-select>
        </div>
        <span flex></span>
        <div layout="column" layout-align="center center">
          <div layout="row" layout-align="center center">
            <v-btn @click="subtract2" icon color="secondary" small depressed>
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn @click="today2" color="secondary" depressed outline small>{{$t('stats.today')}}</v-btn>
            <v-btn @click="add2" icon color="secondary" small depressed>
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
          <span>{{displayedDate2}}</span>
        </div>
      </div>
    </div>
    <div
      layout="column"
      layout-align="start start"
      class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white"
    >
      <reactive-chart
        :is="'bar-chart'"
        :chart-data="chartData2"
        :options="options2"
        style="width: 100%"
      ></reactive-chart>
    </div>

    <div
      layout="column"
      layout-align="start start"
      class="full-width mb20-pc px2-pc pb1-pc mb2-mobile px1-mobile bg-white"
      style="margin-top :10px"
    >
      <div
        layout="row"
        layout-align="start center"
        class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc"
      >{{$t('stats.accounts')}}</div>
    </div>
    <div
      layout="column"
      layout-align="start start"
      class="full-width pt3-pc pb5-pc px2-pc pa1-mobile bg-white"
    >
      <reactive-chart
        :is="'pie-chart'"
        :chart-data="chartData3"
        :options="options3"
        style="width: 100%"
      ></reactive-chart>
    </div>
  </div>
</template>

<script>
import Stats from "@/api/stats";
import I18nMixin from "@/mixins/i18n";
import Consts from "@/consts";
import moment from "moment";
import ReactiveChart from "@/plugins/reactive-chart.js";

export default {
  components: {
    ReactiveChart
  },
  mixins: [I18nMixin],
  data() {
    return {
      filters: {
        start: null,
        end: null,
        mode: "week"
      },
      accounts: {},
      stats: [],
      displayFilters: false,
      labels: [],
      dataset: [],
      loading: false,
      chartData: {},
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              display: true
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: false
                //callback: function(value) {if (value % 1 === 0) {return value;}}
              },
              display: true
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      },
      filters2: {
        start: null,
        end: null,
        mode: "week",
        level: 1
      },
      stats2: [],
      displayFilters2: false,
      labels2: [],
      datasetMin: [],
      datasetNat: [],
      datasetSec: [],
      datasetLoc: [],
      loading2: false,
      chartData2: {},
      options2: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              display: true
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: false
                //callback: function(value) {if (value % 1 === 0) {return value;}}
              },
              display: true
            }
          ]
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        }
      },
      chartData3: {},
      options3: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        }
      },
      labels3: []
    };
  },
  mounted() {
    this.initDates();
    this.fetch();
    this.initDates2();
    this.fetchByLevels();
    this.fetchAccounts();
  },
  methods: {
    fetchAccounts() {
      this.loading = true;
      Stats.getAccounts().then(res => {
        this.accounts = res.data;
        this.loading = false;
        this.labels3 = [];
        this.labels3.push(this.$t("filters.status_active"));
        this.labels3.push(this.$t("filters.status_inactive"));
        this.chartData3 = {
          labels: this.labels3,
          datasets: [
            {
              data: [this.accounts.enabled, this.accounts.disabled],
              backgroundColor: ["#2E3B7F", "#E91E63"],
              borderColor: ["#3d4fa9", "#d11553"],
              borderWidth: 1
            }
          ]
        };
      });
    },
    fetch() {
      this.loading = true;
      Stats.getConnections(this.filters).then(res => {
        this.stats = res.data;
        this.loading = false;
        this.labels = [];
        this.dataset = [];

        for (let i in this.stats) {
          switch (this.filters.mode) {
            case "week":
            case "month":
              this.labels.push(this.formatDateShortI18n(i));
              break;
            case "year":
              this.labels.push(moment(i).format("MMMM"));
              break;
          }
          this.dataset.push(this.stats[i]);
        }

        this.chartData = {
          labels: this.labels,
          datasets: [
            {
              data: this.dataset,
              backgroundColor: "#589C8F", //Main
              borderColor: "#539387", //45%
              borderWidth: 1,
              hoverBackgroundColor: "#9dc8c0", //70%
              hoverBorderColor: "#6caca1", //55%
              hoverBorderWidth: 1
            }
          ]
        };
      });
    },
    fetchByLevels() {
      this.loading2 = true;
      Stats.getConnections(this.filters2).then(res => {
        this.stats2 = res.data;
        this.loading2 = false;
        this.labels2 = [];
        this.datasetMin = [];
        this.datasetNat = [];
        this.datasetSec = [];
        this.datasetLoc = [];

        for (let i in this.stats2) {
          switch (this.filters2.mode) {
            case "week":
            case "month":
              this.labels2.push(this.formatDateShortI18n(i));
              break;
            case "year":
              this.labels2.push(moment(i).format("MMMM"));
              break;
          }
          this.datasetMin.push(this.stats2[i][Consts.MINISTRY]);
          this.datasetNat.push(this.stats2[i][Consts.NATIONAL]);
          this.datasetSec.push(this.stats2[i][Consts.SECTORAL]);
          this.datasetLoc.push(this.stats2[i][Consts.LOCAL]);
        }

        this.chartData2 = {
          labels: this.labels2,
          datasets: [
            {
              label: this.levelLabel(Consts.MINISTRY),
              data: this.datasetMin,
              backgroundColor: "#2E3B7F", //Main
              borderColor: "#3d4fa9", //45%
              borderWidth: 1,
              hoverBackgroundColor: "#8f9bd6", //70%
              hoverBorderColor: "#5668c2", //55%
              hoverBorderWidth: 1
            },
            {
              label: this.levelLabel(Consts.NATIONAL),
              data: this.datasetNat,
              backgroundColor: "#E91E63", //Main
              borderColor: "#d11553", //45%
              borderWidth: 1,
              hoverBackgroundColor: "#f1749e", //70%
              hoverBorderColor: "#ea2e6d", //55%
              hoverBorderWidth: 1
            },
            {
              label: this.levelLabel(Consts.SECTORAL),
              data: this.datasetSec,
              backgroundColor: "#589C8F", //Main
              borderColor: "#539387", //45%
              borderWidth: 1,
              hoverBackgroundColor: "#9dc8c0", //70%
              hoverBorderColor: "#6caca1", //55%
              hoverBorderWidth: 1
            },
            {
              label: this.levelLabel(Consts.LOCAL),
              data: this.datasetLoc,
              backgroundColor: "#795548", //Main
              borderColor: "#8f6556", //45%
              borderWidth: 1,
              hoverBackgroundColor: "#c6aa9f", //70%
              hoverBorderColor: "#a97f70", //55%
              hoverBorderWidth: 1
            }
          ]
        };
      });
    },
    initDates() {
      let startOfWeek = moment()
        .startOf("isoWeek")
        .toDate();
      startOfWeek = moment(startOfWeek).format("YYYY-MM-DD");
      let endOfWeek = moment()
        .endOf("isoWeek")
        .toDate();
      endOfWeek = moment(endOfWeek).format("YYYY-MM-DD");
      this.filters.start = startOfWeek;
      this.filters.end = endOfWeek;
    },
    initDates2() {
      let startOfWeek = moment()
        .startOf("isoWeek")
        .toDate();
      startOfWeek = moment(startOfWeek).format("YYYY-MM-DD");
      let endOfWeek = moment()
        .endOf("isoWeek")
        .toDate();
      endOfWeek = moment(endOfWeek).format("YYYY-MM-DD");
      this.filters2.start = startOfWeek;
      this.filters2.end = endOfWeek;
    },
    today() {
      let start = null;
      let end = null;
      switch (this.filters.mode) {
        case "week":
          start = moment()
            .startOf("isoWeek")
            .toDate();
          end = moment()
            .endOf("isoWeek")
            .toDate();
          break;
        case "month":
          start = moment()
            .startOf("month")
            .toDate();
          end = moment()
            .endOf("month")
            .toDate();
          break;
        case "year":
          start = moment()
            .startOf("year")
            .toDate();
          end = moment()
            .endOf("year")
            .toDate();
          break;
      }
      start = moment(start).format("YYYY-MM-DD");
      end = moment(end).format("YYYY-MM-DD");
      this.filters.start = start;
      this.filters.end = end;
      this.fetch();
    },
    today2() {
      let start = null;
      let end = null;
      switch (this.filters2.mode) {
        case "week":
          start = moment()
            .startOf("isoWeek")
            .toDate();
          end = moment()
            .endOf("isoWeek")
            .toDate();
          break;
        case "month":
          start = moment()
            .startOf("month")
            .toDate();
          end = moment()
            .endOf("month")
            .toDate();
          break;
        case "year":
          start = moment()
            .startOf("year")
            .toDate();
          end = moment()
            .endOf("year")
            .toDate();
          break;
      }
      start = moment(start).format("YYYY-MM-DD");
      end = moment(end).format("YYYY-MM-DD");
      this.filters2.start = start;
      this.filters2.end = end;
      this.fetchByLevels();
    },
    /*onModeChange(){
				let start = null;
				let end = null;
				switch(this.filters.mode){
					case 'week':
						start = moment(this.filters.start).startOf('isoWeek').toDate();
						end = moment(this.filters.start).endOf('isoWeek').toDate();
						break;
					case 'month':
						start = moment(this.filters.start).startOf('month').toDate();
						end = moment(this.filters.start).endOf('month').toDate();
						break;
					case 'year':
						start = moment(this.filters.start).startOf('year').toDate();
						end = moment(this.filters.start).endOf('year').toDate();
						break;
				}
				start = moment(start).format('YYYY-MM-DD');
				end = moment(end).format('YYYY-MM-DD');
				this.filters.start = start;
				this.filters.end = end;
				this.fetch();
			},
			onModeChange2(){
				let start = null;
				let end = null;
				switch(this.filters2.mode){
					case 'week':
						start = moment(this.filters2.start).startOf('isoWeek').toDate();
						end = moment(this.filters2.start).endOf('isoWeek').toDate();
						break;
					case 'month':
						start = moment(this.filters2.start).startOf('month').toDate();
						end = moment(this.filters2.start).endOf('month').toDate();
						break;
					case 'year':
						start = moment(this.filters2.start).startOf('year').toDate();
						end = moment(this.filters2.start).endOf('year').toDate();
						break;
				}
				start = moment(start).format('YYYY-MM-DD');
				end = moment(end).format('YYYY-MM-DD');
				this.filters2.start = start;
				this.filters2.end = end;
				this.fetchByLevels();
			},*/
    add() {
      let start = this.filters.start;
      let end = this.filters.end;
      switch (this.filters.mode) {
        case "week":
          start = moment(start).add(7, "days");
          end = moment(end).add(7, "days");
          break;
        case "month":
          start = moment(start).add(1, "months");
          end = moment(start)
            .endOf("month")
            .toDate();
          end = moment(end);
          break;
        case "year":
          start = moment(start).add(1, "years");
          end = moment(start)
            .endOf("year")
            .toDate();
          end = moment(end);
          break;
      }
      this.filters.start = start.format("YYYY-MM-DD");
      this.filters.end = end.format("YYYY-MM-DD");
      this.fetch();
    },
    add2() {
      let start = this.filters2.start;
      let end = this.filters2.end;
      switch (this.filters2.mode) {
        case "week":
          start = moment(start).add(7, "days");
          end = moment(end).add(7, "days");
          break;
        case "month":
          start = moment(start).add(1, "months");
          end = moment(start)
            .endOf("month")
            .toDate();
          end = moment(end);
          break;
        case "year":
          start = moment(start).add(1, "years");
          end = moment(start)
            .endOf("year")
            .toDate();
          end = moment(end);
          break;
      }
      this.filters2.start = start.format("YYYY-MM-DD");
      this.filters2.end = end.format("YYYY-MM-DD");
      this.fetchByLevels();
    },
    subtract() {
      let start = this.filters.start;
      let end = this.filters.end;
      switch (this.filters.mode) {
        case "week":
          start = moment(start).subtract(7, "days");
          end = moment(end).subtract(7, "days");
          break;
        case "month":
          start = moment(start).subtract(1, "months");
          end = moment(start)
            .endOf("month")
            .toDate();
          end = moment(end);
          break;
        case "year":
          start = moment(start).subtract(1, "years");
          end = moment(start)
            .endOf("year")
            .toDate();
          end = moment(end);
          break;
      }
      this.filters.start = moment(start).format("YYYY-MM-DD");
      this.filters.end = moment(end).format("YYYY-MM-DD");
      this.fetch();
    },
    subtract2() {
      let start = this.filters2.start;
      let end = this.filters2.end;
      switch (this.filters2.mode) {
        case "week":
          start = moment(start).subtract(7, "days");
          end = moment(end).subtract(7, "days");
          break;
        case "month":
          start = moment(start).subtract(1, "months");
          end = moment(start)
            .endOf("month")
            .toDate();
          end = moment(end);
          break;
        case "year":
          start = moment(start).subtract(1, "years");
          end = moment(start)
            .endOf("year")
            .toDate();
          end = moment(end);
          break;
      }
      this.filters2.start = moment(start).format("YYYY-MM-DD");
      this.filters2.end = moment(end).format("YYYY-MM-DD");
      this.fetchByLevels();
    },
    resetFilters() {
      this.filters = {
        start: null,
        end: null,
        mode: "week"
      };
      this.initDates();
      this.fetch();
    },
    resetFilters2() {
      this.filters2 = {
        start: null,
        end: null,
        mode: "week",
        level: 1
      };
      this.initDates2();
      this.fetchByLevels();
    },
    levelLabel(l) {
      switch (l) {
        case Consts.MINISTRY:
          return this.$t("users.lv_min");
        case Consts.NATIONAL:
          return this.$t("users.lv_nat");
        case Consts.SECTORAL:
          return this.$t("users.lv_sec");
        case Consts.LOCAL:
          return this.$t("users.lv_loc");
      }
    }
  },
  computed: {
    modes() {
      return [
        { value: "week", text: this.$t("_.week") },
        { value: "month", text: this.$t("_.month") },
        { value: "year", text: this.$t("_.year") }
      ];
    },
    displayedDate() {
      switch (this.filters.mode) {
        case "week":
          return (
            this.formatDateI18n(this.filters.start) +
            " - " +
            this.formatDateI18n(this.filters.end)
          );
        case "month":
          return this.formatMonthHumanI18n(this.filters.start);
        case "year":
          return moment(this.filters.start).format("YYYY");
      }
    },
    displayedDate2() {
      switch (this.filters2.mode) {
        case "week":
          return (
            this.formatDateI18n(this.filters2.start) +
            " - " +
            this.formatDateI18n(this.filters2.end)
          );
        case "month":
          return this.formatMonthHumanI18n(this.filters2.start);
        case "year":
          return moment(this.filters2.start).format("YYYY");
      }
    }
  }
};
</script>
<style scoped>
</style>